<template>
  <section :class="{live: isLive}" v-on:click="sectionClicked">
    <div class="theHeader">
      <button class="backBtn" :class="{open: showBack}"
        v-on:click="goBack"><span>Kembali</span></button>
      <div class="sound withBack" v-if="!isLive" v-on:click="$emit('play')">
        <div :class="{soundBtn: true, on: audioPlaying}"></div>
        <div class="soundLabel">
          Sound
          <span v-if="audioPlaying">On</span>
          <span v-else>Off</span>
        </div>
      </div>
      <div class="menuToggle" v-on:click.stop="openMenu = !openMenu"></div>
      <div :class="{menu: true, open: openMenu}" v-on:click.stop="doNothing">
        <div class="menuItem left" v-on:click="openDownload">Download Brosur</div>
        <div class="menuItem right" v-on:click="openFaq">FAQ</div>
      </div>
    </div>
    <div v-if="finished" class="finishedCnt">
      <div class="finished">
        <h4>Main Stage</h4>
        <div class="videoCnt"></div>
        <p>Acara sekarang telah selesai. Silahkan lihat rekaman acara disini.</p>
        <a href="https://youtu.be/rtNSPwxRLvo" class="btn orange rounded lg" target="_blank">
          Tonton Rekaman Acara
        </a>
      </div>
    </div>
    <div v-else>
      <div :class="{videoCnt: true, hideChat: hideChat}" v-if="isLive">
        <perfect-scrollbar class="theVideo">
          <div class="iframeCnt">
            <VuePlyr>
              <div class="plyr__video-embed">
                <iframe :src="videoUri"
                  title="YouTube video player" frameborder="0"
                  width="100%" height="100%"
                  allowfullscreen allowtransparency
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media;
                  gyroscope; picture-in-picture"></iframe>
              </div>
            </VuePlyr>
          </div>
          <div class="videoInfo">
            <h4>Youthfuel Summerfest - Amunisi Segar Untuk Kulitmu</h4>
            <div class="shareBtnCnt">
              <div class="view"><img src="../assets/share/group.svg">
                <span id="visitorCount">1</span></div>
              <div class="shareBtn" v-on:click="openShare">
                <img src="../assets/share/share.svg">
                Bagikan</div>
            </div>
            <div class="speakers">
              <div class="speaker clark" v-on:click="openProfile('clark')"></div>
              <div class="speaker sarah" v-on:click="openProfile('sarah')"></div>
              <div class="speaker dhelya" v-on:click="openProfile('dhelya')"></div>
              <div class="speaker yura" v-on:click="openProfile('yura')"></div>
              <div class="speaker testimoni" v-on:click="openProfile('testimoni')"></div>
            </div>
          </div>
        </perfect-scrollbar>
        <div class="showChat" v-on:click="hideChat = false"
          v-if="hideChat"></div>
        <div class="chatArea">
          <div class="stickyCnt">
            <div class="stickyChat" v-if="stickyChat">
              <h4>Pinned by {{stickyChat.name}}</h4>
              <p>{{stickyChat.message}}</p>
            </div>
            <div :class="{pollingBtn: true, open: epl1ok.open}"
              v-on:click="openPooling">
              <h4>{{epl1ok.title}}</h4>
              <p>Polling berakhir dalam {{cdp1.m}}:{{cdp1.s}}</p>
            </div>
            <div :class="{pollingBtn: true, open: epl2ok.open}"
              v-on:click="openPooling2">
              <h4>{{epl2ok.title}}</h4>
              <p>Polling berakhir dalam {{cdp2.m}}:{{cdp2.s}}</p>
            </div>
          </div>
          <div class="chatHeader">
            <div class="hideChat" v-on:click="hideChat = true"></div>
            Stream Chat
          </div>
          <perfect-scrollbar class="theChat" ref="wrapper"
            v-on:scroll="scrolled">
            <div class="loadingChat" v-if="loadingChat"></div>
            <div class="chatWrapper" v-else>
              <div class="msgItem" v-for="(m, i) in messages" :key="i">
                <div class="msgContent">
                  <h5>{{m.name}}</h5>{{m.message}}
                </div>
              </div>
            </div>
            <input ref="scHelper" class="scHelper">
          </perfect-scrollbar>
          <div class="chatFooter">
            <div class="scrollChat" v-if="chatScrolled"
              v-on:click="scrollWrapper">Lihat chat baru</div>
            <div class="textField" contenteditable
              placeholder="Tulis pesan kamu..."
              v-on:keydown="keyDown" ref="field"
              v-on:focus="emojiOpen = false"></div>
            <div class="emojiCnt" v-if="emojiOpen">
              <VEmojiPicker @select="selectEmoji" />
            </div>
            <div class="attachmentIcon" v-on:click="openEmoji"></div>
            <div class="sendBtn" v-on:click="sendMessage">
              Kirim <span>Pesan</span>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="stages">
          <div class="stageHeader">
            <h4>Ada siapa aja di Main Stage?</h4>
          </div>
          <div class="stageItem clark" v-on:click="openProfile('clark')"></div>
          <div class="stageItem sarah" v-on:click="openProfile('sarah')"></div>
          <div class="stageItem dhelya" v-on:click="openProfile('dhelya')"></div>
          <div class="stageItem yura" v-on:click="openProfile('yura')"></div>
          <div class="stageItem testimoni" v-on:click="openProfile('testimoni')"></div>
          <div class="stageFooter">
            <div class="countdown">
              <div class="cdItem">
                {{cd.h}}<span>jam</span>
              </div>
              <div class="cdItem">
                {{cd.m}}<span>menit</span>
              </div>
              <div class="cdItem">
                {{cd.s}}<span>detik</span>
              </div>
            </div>
            <div class="stftAction">
              <div class="actDate">Sabtu, 2 Oktober 2021<br />15:00 - 17:00 WIB</div>
              <button class="btn orange rounded lg actAdd2Cal"
                v-on:click="add2Calendar">Tambah Ke Kalendar</button>
            </div>
          </div>
        </div>
        <div class="cloud cloud1"></div>
        <div class="cloud cloud2"></div>
        <div class="cloud cloud3"></div>
        <div class="cloud cloud1 cloud1a"></div>
        <div class="cloud cloud3 cloud3a"></div>
        <div class="fruitCnt">
          <div class="fruit fr1"></div>
          <div class="fruit fr2"></div>
          <div class="fruit fr3"></div>
          <div class="fruit fr4"></div>
          <div class="fruit fr5"></div>
          <div class="fruit fr6"></div>
          <div class="fruit fr7"></div>
        </div>
      </div>
    </div>
    <div class="copyright">
      <div class="shareFooter" :class="{open: shareOpen}"
        v-on:click.stop="shareOpen = !shareOpen"></div>
      <div class="socialLink" :class="{open: shareOpen}"
        v-on:click.stop="doNothing">
        <div class="sclLabel">Find Us On:</div>
        <a class="sclItem ig" target="_blank"
          href="https://www.instagram.com/nutrilite_id/"></a>
        <a class="sclItem fb" target="_blank"
          href="https://www.facebook.com/NutriliteID"></a>
        <a class="sclItem tw" target="_blank" :href="twUri"></a>
        <a class="sclItem wa" target="_blank" :href="waText"></a>
      </div>
      <div class="copy">
        &copy; Nutrilite Indonesia {{y}}
      </div>
    </div>
    <Add2Calendar ref="add2Calendar"/>
    <Main ref="main"/>
    <Faq ref="faq"/>
    <Pooling ref="pooling"/>
    <Pooling2 ref="pooling2"/>
    <Profile ref="profile"/>
    <Download ref="download"/>
    <ShareDialog ref="shareDialog"/>
  </section>
</template>

<script>
import { VEmojiPicker } from 'v-emoji-picker';
import { mapState } from 'vuex';
import VuePlyr from 'vue-plyr';
import Add2Calendar from '@/components/Add2Calendar.vue';
import Main from '@/components/Main.vue';
import Faq from '@/components/Faq.vue';
import Pooling from '@/components/Pooling.vue';
import Pooling2 from '@/components/Pooling2.vue';
import Profile from '@/components/Profile.vue';
import Download from '@/components/Download.vue';
import ShareDialog from '@/components/ShareDialog.vue';

export default {
  name: 'home',
  components: {
    VEmojiPicker,
    Add2Calendar,
    Main,
    Faq,
    Profile,
    Pooling,
    Pooling2,
    VuePlyr,
    Download,
    ShareDialog,
  },
  data() {
    return {
      y: '',
      name: '',
      isLive: false,
      openMenu: false,
      loadingChat: true,
      emojiOpen: false,
      messages: [],
      chatScrolled: false,
      hideChat: false,
      cd: { h: '--', m: '--', s: '--' },
      cdp1: { m: '--', s: '--' },
      cdp2: { m: '--', s: '--' },
      liveDate: new Date('2021-10-02T08:00:00.000Z'),
      epl1ok: { open: false, ts: 0, title: '' },
      epl2ok: { open: false, ts: 0, title: '' },
      videoId: '6hoooQRV-Bg',
      shareOpen: false,
      visitorCount: 0,
      showBack: false,
      backTimer: null,
      stickyChat: null,
      cdPolling: null,
      cdPolling2: null,
      cdViewers: null,
      finished: true,
    };
  },
  methods: {
    doNothing() {},
    openDownload() {
      this.openMenu = false;
      this.$refs.download.open();
    },
    openFaq() {
      this.openMenu = false;
      this.$refs.faq.open();
    },
    openShare() {
      this.$refs.shareDialog.open();
    },
    openEmoji() {
      this.emojiOpen = !this.emojiOpen;
    },
    openProfile(name) {
      this.$refs.profile.open(name);
    },
    selectEmoji(emoji) {
      this.$refs.field.innerHTML = `${this.$refs.field.innerHTML.trim()} ${emoji.data}`;
    },
    openPooling() {
      this.$refs.pooling.open();
    },
    openPooling2() {
      this.$refs.pooling2.open();
    },
    scrolled(e) {
      this.chatScrolled = (e.srcElement.scrollTop + e.srcElement.clientHeight + 100
        < e.srcElement.scrollHeight);
    },
    sendMessage() {
      this.emojiOpen = false;
      const msg = this.$refs.field.innerHTML
        .replace(/<br\s*[/]?>/gi, '\n')
        .replace(/(<([^>]+)>)/gi, '')
        .replace(/(&([^;]+);)/gi, '')
        .trim();
      this.$refs.field.innerHTML = '';
      if (msg && msg !== '') {
        const msgData = {
          message: msg,
          userId: localStorage.getItem('id'),
          key: this.$config.apiKey,
        };
        this.$socket.emit('chat', msgData);
        this.messages.unshift({ name: this.name, message: msg });
        this.scrollWrapper();
      }
    },
    scrollWrapper() {
      this.chatScrolled = false;
      setTimeout(() => {
        if (!this.$refs.wrapper) return;
        this.$refs.wrapper.$el.scrollTo(0, this.$refs.wrapper.$el.scrollHeight);
      });
    },
    keyDown(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        this.sendMessage();
        e.preventDefault();
      }
    },
    add2Calendar() {
      this.$refs.add2Calendar.open();
    },
    goBack() {
      this.$router.push('/');
    },
    startCoundown() {
      clearInterval(this.cdInterval);
      const now2 = Date.now();
      const dst = this.liveDate.getTime() - now2;
      const h2 = Math.floor((dst % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const m2 = Math.floor((dst % (1000 * 60 * 60)) / (1000 * 60));
      const s2 = Math.floor((dst % (1000 * 60)) / 1000);
      this.cd.h = (h2 < 10) ? `0${h2.toString()}` : h2.toString();
      this.cd.m = (m2 < 10) ? `0${m2.toString()}` : m2.toString();
      this.cd.s = (s2 < 10) ? `0${s2.toString()}` : s2.toString();
      if (dst < 0) {
        this.isLive = true;
        this.$emit('pause');
      }
      this.cdInterval = setInterval(() => {
        const now = Date.now();
        const distance = this.liveDate.getTime() - now;
        const h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const s = Math.floor((distance % (1000 * 60)) / 1000);
        this.cd.h = (h < 10) ? `0${h.toString()}` : h.toString();
        this.cd.m = (m < 10) ? `0${m.toString()}` : m.toString();
        this.cd.s = (s < 10) ? `0${s.toString()}` : s.toString();
        if (distance < 0) {
          clearInterval(this.cdInterval);
          this.$emit('pause');
          this.isLive = true;
        }
      }, 1000);
    },
    animateValue(start, end, duration) {
      const obj = document.getElementById('visitorCount');
      if (start === end) {
        obj.innerHTML = end;
        return;
      }
      const range = end - start;
      let current = start;
      let increment;
      if (range > 100) {
        increment = end > start ? Math.floor(range / 100)
          : -Math.floor(range / 100);
      } else {
        increment = end > start ? 1 : -1;
      }
      const stepTime = Math.abs(Math.floor(duration / range));
      const timer = setInterval(() => {
        current += increment;
        obj.innerHTML = current.toLocaleString('id');
        if ((increment > 0 && current >= end) || (increment < 0 && current <= end)) {
          clearInterval(timer);
        }
      }, stepTime);
    },
    sectionClicked() {
      this.openMenu = false;
      this.shareOpen = false;
      this.showBack = true;
      clearTimeout(this.backTimer);
      this.backTimer = setTimeout(() => {
        this.showBack = false;
      }, 3000);
    },
    getPinned() {
      this.$http.get(this.$config.uri('user/chat/sticky')).then((r) => {
        this.stickyChat = (r.data.status === 200) ? r.data.data : null;
      });
    },
    startCdPolling() {
      clearInterval(this.cdPolling);
      const now2 = Date.now();
      const dst = this.epl1ok.ts * 1000 - now2;
      const m2 = Math.floor((dst % (1000 * 60 * 60)) / (1000 * 60));
      const s2 = Math.floor((dst % (1000 * 60)) / 1000);
      this.cdp1.m = (m2 < 10) ? `0${m2.toString()}` : m2.toString();
      this.cdp1.s = (s2 < 10) ? `0${s2.toString()}` : s2.toString();
      if (dst < 0) {
        this.epl1ok.open = false;
      }
      this.cdPolling = setInterval(() => {
        const now = Date.now();
        const distance = this.epl1ok.ts * 1000 - now;
        const m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const s = Math.floor((distance % (1000 * 60)) / 1000);
        this.cdp1.m = (m < 10) ? `0${m.toString()}` : m.toString();
        this.cdp1.s = (s < 10) ? `0${s.toString()}` : s.toString();
        if (distance < 0) {
          clearInterval(this.cdPolling);
          this.epl1ok.open = false;
        }
      }, 1000);
    },
    startCdPolling2() {
      clearInterval(this.cdPolling2);
      const now2 = Date.now();
      const dst = this.epl2ok.ts * 1000 - now2;
      const m2 = Math.floor((dst % (1000 * 60 * 60)) / (1000 * 60));
      const s2 = Math.floor((dst % (1000 * 60)) / 1000);
      this.cdp2.m = (m2 < 10) ? `0${m2.toString()}` : m2.toString();
      this.cdp2.s = (s2 < 10) ? `0${s2.toString()}` : s2.toString();
      if (dst < 0) {
        this.epl2ok.open = false;
      }
      this.cdPolling2 = setInterval(() => {
        const now = Date.now();
        const distance = this.epl2ok.ts * 1000 - now;
        const m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const s = Math.floor((distance % (1000 * 60)) / 1000);
        this.cdp2.m = (m < 10) ? `0${m.toString()}` : m.toString();
        this.cdp2.s = (s < 10) ? `0${s.toString()}` : s.toString();
        if (distance < 0) {
          clearInterval(this.cdPolling2);
          this.epl2ok.open = false;
        }
      }, 1000);
    },
    getPolling() {
      this.$http.get(this.$config.uri('user/polling')).then((r) => {
        this.epl1ok.open = (r.data.status === 200 && r.data.data.p1en === 1);
        this.epl2ok.open = (r.data.status === 200 && r.data.data.p2en === 1);
        if (this.epl1ok.open) {
          this.epl1ok.title = r.data.data.title1;
          this.epl1ok.ts = r.data.data.p1end;
          this.startCdPolling();
        }
        if (this.epl2ok.open) {
          this.epl2ok.title = r.data.data.title2;
          this.epl2ok.ts = r.data.data.p2end;
          this.startCdPolling2();
        }
      });
    },
  },
  computed: {
    ...mapState(['audioPlaying']),
    videoUri() {
      return 'https://www.youtube.com/embed/'
        + `${this.videoId}`
        + '?amp;iv_load_policy=3&amp;modestbranding=1&amp;'
        + 'playsinline=1&amp;showinfo=0&amp;rel=0&amp;'
        + 'enablejsapi=1';
    },
    shareText() {
      return 'Yuk ikutan #YouthfuelSummerFest bersama @nutrilite_id';
    },
    twUri() {
      return 'https://twitter.com/intent/tweet?url='
        + `${escape('https://nutrilite.co.id/youthfuelsummerfest/')}`
        + `&text=${escape(this.shareText)}&related=Amway,Nutrilite,Collagen`;
    },
    waText() {
      return 'https://api.whatsapp.com/send/?phone&text='
        + `${escape(`${this.shareText} di https://nutrilite.co.id/youthfuelsummerfest/`)}`
        + '&app_absent=0';
    },
  },
  beforeDestroy() {
    this.$socket.emit('out');
    clearInterval(this.cdViewers);
  },
  mounted() {
    const d = new Date();
    this.y = d.getFullYear();
    this.name = localStorage.getItem('name');
    const token = localStorage.getItem('token');
    if (!token) {
      this.$refs.main.open((name) => {
        this.name = name;
      });
    }
    // this.sockets.subscribe('message', (msg) => {
    //   if (!this.chatScrolled) {
    //     if (this.messages.length > 50) this.messages = this.messages.slice(0, 49);
    //     this.messages.unshift(msg);
    //     this.scrollWrapper();
    //   }
    // });
    // this.sockets.subscribe('epl1ok', (msg) => {
    //   this.getPolling();
    // });
    // this.sockets.subscribe('epl2ok', (msg) => {
    //   this.getPolling();
    // });
    // this.sockets.subscribe('epl1no', (msg) => {
    //   this.epl1no = { open: false, ts: 0, title: '' };
    // });
    // this.sockets.subscribe('epl2no', (msg) => {
    //   this.epl2no = { open: false, ts: 0, title: '' };
    // });
    // this.sockets.subscribe('pinnedok', (msg) => {
    //   this.getPinned();
    // });
    // this.$http.get(this.$config.uri('user/stream/viewers')).then((r) => {
    //   this.animateValue(this.visitorCount, r.data.total, 30000);
    //   setTimeout(() => {
    //     this.visitorCount = r.data.total;
    //   }, 30000);
    // });
    // this.cdViewers = setInterval(() => {
    //   this.$http.get(this.$config.uri('user/stream/viewers')).then((r) => {
    //     this.animateValue(this.visitorCount, r.data.total, 30000);
    //     setTimeout(() => {
    //       this.visitorCount = r.data.total;
    //     }, 30000);
    //   });
    // }, 600000);
    // this.$socket.emit('sign', {
    //   key: this.$config.apiKey,
    //   userId: localStorage.getItem('id'),
    // });
    // this.getPinned();
    // this.$http.get(this.$config.uri('user/chat/all')).then((r) => {
    //   this.loadingChat = false;
    //   this.messages = (r.data.status === 200) ? r.data.data : [];
    //   setTimeout(() => {
    //     this.scrollWrapper();
    //   }, 200);
    // });
    // const now = new Date();
    // this.isLive = now.getTime() >= this.liveDate.getTime();
    // if (!this.isLive) {
    //   this.startCoundown();
    // } else {
    //   this.$emit('pause');
    // }
  },
};
</script>

<style lang="scss">
  .iframeCnt {
    .plyr__video-embed, .plyr__video-wrapper--fixed-ratio{
      box-sizing: border-box !important;
      height: 44.3vw !important;
      padding: 0 !important;
      @media (max-width: 960px) {
        height: 70vw !important;
      }
      @media (max-width: 680px) and (max-height: 420px) {
        height: 100vh !important;
      }
    }
  }
</style>

<style scoped lang="scss">
.finishedCnt{
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  @media (max-height: 780px) {
    position: static;
    padding: 140px 0 60px;
    display: block;
  }
  @media (max-width: 680px) {
    position: static;
    padding: 80px 0;
    display: block;
    min-height: 100vh;
  }
  .finished{
    width: 860px;
    text-align: center;
    margin: 0 auto;
    @media (max-width: 960px) {
      width: auto;
      margin: 0 20px;
    }
    h4{
      font-family: CarlaSansBold;
      font-size: 40px;
      margin: 0 auto 40px;
    }
    .videoCnt{
      height: 480px;
      margin-bottom: 20px;
      background-image: url(../assets/Youtube-Thumbnail.jpg);
      background-size: cover;
      background-position: center;
      border-radius: 10px;
      @media (max-width: 960px) {
        height: 400px;
      }
      @media (max-width: 680px) {
        height: 200px;
      }
    }
    p{
      font-size: 20px;
      marks: 0 0 20px;
    }
    .btn{
      @media (max-width: 680px) {
        font-size: 16px;
      }
    }
    .comingSoon{
      font-size: 20px;
    }
  }
}

section{
  background-color: #ffc9ca;
  background-image: url(../assets/mainstage-bg.jpg);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: fixed;
  left: 0; top: 0; right: 0; bottom: 0;
  @media (max-height: 680px) {
    position: static;
  }
  @media (max-width: 680px) {
    position: static;
  }
  .theHeader{
    position: fixed;
    overflow: hidden;
    left: 0; right: 0;
    z-index: 992;
    height: 80px;
    @media (max-width: 680px) {
      height: 60px;
    }
  }
  &.live{
    .theHeader{
      padding: 6px 20px;
      background-color: #ec9fd5;
      background-image: linear-gradient(to right, #ec9fd5, #e273c1);
      height: auto !important;
      @media (max-width: 960px) {
        padding: 0;
      }
      .menuToggle{
        box-shadow: none;
        display: none;
      }
      .backBtn{
        position: relative;
        left: auto; top: auto;
        box-shadow: none;
        height: 44px;
        line-height: 44px;
        box-sizing: border-box;
        @media (max-width: 960px) {
          position: fixed;
          z-index: 999;
          width: 36px; height: 36px;
          line-height: 36px;
          padding: 0;
          left: 10px; top: 10px;
          left: -46px;
          span{
            display: none;
          }
          &.open{
            left: 10px;
          }
        }
        &:before{
          top: 12px;
          @media (max-width: 960px) {
            top: 9px; left: 9px;
            width: 18px; height: 18px;
          }
        }
      }
      .menu{
        top: 6px; right: 20px;
        box-shadow: none;
      }
    }
    .showChat{
      position: absolute;
      background-color: #32aeda;
      width: 30px; height: 40px;
      top: 50%; right: 0;
      border-radius: 5px 0 0 5px;
      transform: translateY(-50%);
      transition: all .3s ease;
      background-image: url(../assets/show-chat.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
      opacity: .6;
      z-index: 9999;
      @media (max-width: 960px) {
        bottom: 0; top: auto; right: 16px;
        margin-bottom: -5px;
        opacity: 1;
        transform: rotate(90deg);
      }
      @media (max-width: 680px) and (max-height: 420px) {
        transform: none;
        opacity: 1;
        margin: 0;
        bottom: auto; right: 0; top: 40px;
      }
      &:hover{
        opacity: 1;
        width: 40px;
      }
    }
    .stickyCnt{
      position: absolute;
      z-index: 9;
      top: 47px; right: 0; left: 0;
      @media (max-width: 960px) {
        top: 38px;
      }
      .stickyChat{
        background-color: #fff;
        padding: 8px 16px 10px;
        box-shadow: 0 4px 4px rgba(0,0,0,.2);
        background-color: #fff6c9;
        position: relative;
        &:before{
          content: "";
          position: absolute;
          width: 10px; height: 10px;
          left: 16px; top: 10px;
          background-image: url(../assets/pinned.svg);
          background-size: 100% auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .6;
        }
        h4{
          margin: 0 0 4px 16px;
          font-size: 11px;
          color: #767676;
        }
        p{
          font-weight: normal;
          font-size: 15px;
          margin: 0;
          color: #444;
          line-height: 1;
          @media (max-width: 680px) {
            font-size: 14px;
          }
        }
      }
      .pollingBtn{
        box-sizing: border-box;
        background-color: #e687c9;
        color: #fff;
        padding: 10px 20px;
        border-bottom: #fcdf51 3px solid;
        box-shadow: 0 2px 10px rgba(0, 0, 0, .5);
        font-size: 18px;
        border-radius: 2px;
        transition: all .3s ease;
        margin: 10px 16px 0;
        display: none;
        @media (max-width: 680px) {
          padding-left: 12px;
          padding-right: 12px;
        }
        h4{
          margin: 0;
          line-height: 1.2;
          font-size: 18px;
          @media (max-width: 680px) {
            font-size: 15px;
          }
        }
        &.open{
          display: block;
        }
        @media (max-width: 960px) {
          // top: calc(50vw + 52px + 86px);
          // width: auto;
          // left: 16px;
          // padding: 10px 20px;
          // font-size: 16px;
        }
        &:hover{
          box-shadow: 0 2px 10px rgba(0, 0, 0, .8);
          background-color: #c76fac;
          cursor: pointer;
        }
        p{
          margin: 0;
          font-size: 14px;
          font-weight: normal;
        }
      }
    }
    .videoCnt{
      position: fixed;
      left: 0; right: 0; bottom: 0; top: 56px;
      background-image: url(../assets/mainstage-bg.jpg);
      background-size: cover;
      background-position: center;
      display: flex;
      @media (max-width: 960px) {
        display: block;
        top: 0;
      }
      .theVideo{
        height: 100%;
        position: absolute;
        left: 0; right: 359px;
        overflow-y: auto;
        transition: all .3s ease;
        @media (max-width: 960px) {
          position: static;
        }
        @media (max-width: 680px) and (max-height: 420px) {
          width: calc(100% - 260px);
        }
        .iframeCnt{
          // height: 40vw;
          // max-height: 80%;
          background-color: #222;
          position: relative;
          @media (max-width: 960px) {
            // height: 60vw;
          }
          iframe{
            width: 100%; height: 100%;
          }
        }
        .videoInfo{
          padding: 20px;
          position: relative;
          @media (max-width: 960px) {
            padding: 16px 14px;
            display: none;
          }
          @media (max-width: 680px) and (max-height: 420px) {
            display: block;
          }
          .shareBtnCnt{
            @media (max-width: 960px) {
              display: flex;
            }
          }
          .shareBtn{
            width: 168px;
            position: absolute;
            right: 20px; top: 24px;
            cursor: pointer;
            background-color: #fcdf51;
            color: #a8483d;
            border-radius: 3px;
            text-align: center;
            box-shadow: 2px 2px 4px rgba(0,0,0,.2);
            transition: all .3s ease;
            height: 44px;
            padding: 0;
            line-height: 44px;
            font-size: 18px;
            padding-top: 2px;
            box-sizing: border-box;
            font-family: CarlaSansBold;
            @media (max-width: 960px) {
              height: 34px;
              font-size: 14px;
              line-height: 34px;
              width: 120px;
              position: static;
            }
            img{
              height: 26px;
              margin-right: 6px;
              vertical-align: middle;
              @media (max-width: 960px) {
                height: 20px;
                margin-right: 2px;
              }
            }
            &:hover{
              background-color: #ffe66d;
              box-shadow: 2px 2px 4px rgba(0,0,0,.4);
            }
          }
          .view{
            position: absolute;
            right: 210px; top: 28px;
            font-size: 20px;
            @media (max-width: 960px) {
              position: static;
              margin-right: 20px;
              font-size: 18px;
              margin-top: 2px;
            }
            img{
              height: 40px;
              margin-right: 6px;
              vertical-align: middle;
              @media (max-width: 960px) {
                height: 34px;
                margin-right: 8px;
              }
            }
          }
          h4{
            font-size: 26px;
            margin: 0 0 40px;
            padding: 10px 320px 0 0;
            @media (max-width: 960px) {
              padding: 0;
              font-size: 16px;
              margin-bottom: 10px;
            }
          }
          .speakers{
            display: flex;
            padding: 20px 0 60px;
            @media (max-width: 960px) {
              display: block;
              padding-bottom: 0;
            }
            .speaker{
              width: 25%;
              height: 140px;
              background-size: contain;
              background-position: center;
              background-repeat: no-repeat;
              cursor: pointer;
              transition: all .3s ease;
              @media (max-width: 960px) {
                width: auto;
                height: 160px;
                margin-bottom: 20px;
              }
              &:hover{
                transform: scale(1.1);
              }
              &.clark{
                background-image: url(https://storage.googleapis.com/deepdivedjkt/clg/speakers/clark.png);
                @media (max-width: 960px) {
                  margin-right: 40px;
                  height: 180px;
                }
              }
              &.sarah{
                background-image: url(https://storage.googleapis.com/deepdivedjkt/clg/speakers/sarah.png);
              }
              &.dhelya{
                background-image: url(https://storage.googleapis.com/deepdivedjkt/clg/speakers/dhelya.png);
                height: 120px;
                margin-top: 10px;
              }
              &.yura{
                background-image: url(https://storage.googleapis.com/deepdivedjkt/clg/speakers/yura.png);
              }
              &.testimoni{
                background-image: url(https://storage.googleapis.com/deepdivedjkt/clg/speakers/speaker-testimoni.png);
              }
            }
          }
        }
      }
      .chatArea{
        transition: all .3s ease;
        width: 359px;
        right: 0; top: 0;
        height: 100%;
        position: absolute;
        background-color: #222;
        border-left: #efbab9 1px solid;
        box-sizing: border-box;
        @media (max-width: 960px) {
          border: none;
          left: 0; right: 0; bottom: 0; top: auto;
          height: calc(100% - 70vw);
          top: auto;
          width: auto;
        }
        @media (max-width: 680px) and (max-height: 420px) {
          height: auto;
          top: 0; left: auto;
          width: 260px;
          z-index: 999;
        }
        .chatHeader{
          background-color: #32aeda;
          border-bottom: #1691cc 1px solid;
          color: #fff;
          font-family: CarlaSansBold;
          font-size: 18px;
          text-align: center;
          padding: 13px 0 10px;
          position: relative;
          @media (max-width: 960px) {
            text-align: left;
            padding: 10px 20px 7px;
            font-size: 16px;
          }
          @media (max-width: 680px) and (max-height: 420px) {
            text-align: center;
          }
          .hideChat{
            width: 36px; height: 36px;
            position: absolute;
            left: 8px; top: 5px;
            background-image: url(../assets/hide-chat.png);
            background-size: 20px auto;
            background-position: center;
            background-repeat: no-repeat;
            transition: all .3s ease;
            border-radius: 3px;
            cursor: pointer;
            @media (max-width: 960px) {
              left: auto; right: 10px; top: 0;
              transform: rotate(90deg);
            }
            @media (max-width: 680px) and (max-height: 420px) {
              transform: none;
              right: auto; left: 10px;
            }
            &:hover{
              background-color: #1691cc;
            }
          }
        }
        .theChat{
          position: absolute;
          top: 47px; bottom: 114px; left: 0; right: 0;
          overflow-y: auto;
          background-image: url(../assets/game-bg.png);
          background-position: center;
          background-size: cover;
          @media (max-width: 960px) {
            bottom: 62px; top: 38px;
          }
          .loadingChat{
            position: absolute;
            top: 0; bottom: 0; left: 0; right: 0;
            background-image: url(../assets/loading.svg);
            background-size: 46px auto;
            background-position: center;
            background-repeat: no-repeat;
            opacity: .4;
          }
          .chatWrapper{
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            min-height: 100%;
            padding: 100px 0 0;
            box-sizing: border-box;
            flex-flow: column-reverse;
          }
        }
        .chatFooter{
          position: absolute;
          left: 0; right: 0; bottom: 0;
          background-color: #eb9ed5;
          padding: 12px 16px 64px;
          box-sizing: border-box;
          box-shadow: 2px 2px 8px rgba(0,0,0,.2);
          z-index: 99;
          @media (max-width: 960px) {
            padding-bottom: 16px;
            padding-top: 8px;
          }
          .scrollChat{
            position: absolute;
            top: -46px; left: 50%;
            transform: translateX(-50%);
            box-sizing: border-box;
            background-color: #c54aa1;
            color: #fff;
            border-radius: 50px;
            padding: 6px 20px;
            font-size: 14px;
            font-weight: normal;
            padding-left: 36px;
            white-space: nowrap;
            cursor: pointer;
            transition: all .3s ease;
            box-shadow: 0 2px 4px rgba(0,0,0,.4);
            z-index: 9;
            outline: 0;
            &:hover{
              background-color: #e47ec5;
            }
            &:before{
              content: "";
              position: absolute;
              left: 12px; width: 20px; top: 4px; height: 20px;
              background-image: url(../assets/down-arrow.png);
              background-size: 18px auto;
              background-position: center;
              background-repeat: no-repeat;
            }
          }
          .emojiCnt{
            margin-top: 10px;
          }
          .textField{
            background-color: #ffe2f7;
            padding: 8px 16px;
            border-radius: 5px;
            outline: 0 !important;
            max-height: 110px;
            overflow-y: auto;
            min-height: 38px;
            box-sizing: border-box;
            line-height: 1.4;
            font-weight: normal;
            color: #444;
            @media (max-width: 960px) {
              margin-right: 64px;
              font-size: 14px;
              padding: 10px 10px 9px;
            }
            &:focus{
              background-color: #fff;
            }
            &.hasImg{
              margin-bottom: 100px;
            }
            &:empty:before {
              content: attr(placeholder);
              color: #767676;
              display: block;
              position:absolute;
            }
          }
          .attachmentIcon,
          .sendBtn{
            width: 36px; height: 36px;
            border-radius: 50%;
            position: absolute;
            right: 16px; bottom: 20px;
            background-position: center;
            background-size: 20px auto;
            background-repeat: no-repeat;
            cursor: pointer;
            @media (max-width: 960px) {
              height: 38px;
              font-size: 15px;
              span{
                display: none;
              }
            }
            &:hover{
              background-color: #ddd;
            }
            &.sendBtn{
              width: 120px;
              border-radius: 3px;
              color: #a8483d;
              background-color: #fcdf51;
              line-height: 36px;
              text-align: center;
              box-shadow: 2px 2px 4px rgba(0,0,0,.2);
              transition: all .3s ease;
              @media (max-width: 960px) {
                width: 56px;
                line-height: 38px;
                right: 14px;
                bottom: 16px;
              }
              &:hover{
                background-color: #ffe66d;
                box-shadow: 2px 2px 4px rgba(0,0,0,.4);
              }
            }
            &.attachmentIcon{
              right: 146px; bottom: 19px;
              background-image: url(../assets/grinning.png);
              background-size: 18px auto;
              transition: all .3s ease;
              @media (max-width: 960px) {
                display: none;
              }
              &:hover{
                background-color: #c54aa1;
              }
            }
          }
        }
      }
      &.hideChat{
        .theVideo{
          right: 0;
          @media (max-width: 960px) {
            .videoInfo{
              display: block;
            }
          }
          @media (max-width: 680px) and (max-height: 420px) {
            width: 100%;
          }
        }
        .chatArea{
          right: -359px;
          @media (max-width: 960px) {
            right: 0; transform: translateY(100%);
          }
          @media (max-width: 680px) and (max-height: 420px) {
            right: 0; transform: translateX(100%);
          }
        }
      }
    }
    .copyright{
      display: none;
    }
  }
}

.scHelper{
  height: 1px;
  border: none;
  background: none;
  outline: 0;
  color: #222;
}
.msgItem{
  padding: 2px 16px;
  .msgContent{
    display: inline-block;
    background-color: #fff0a9;
    padding: 7px 12px 4px;
    line-height: 1.3;
    font-size: 15px;
    font-weight: normal;
    border-radius: 10px;
    margin-right: auto;
    max-width: 400px;
    color: #222;
    position: relative;
    @media (max-width: 960px) {
      font-size: 14px;
    }
    h5{
      margin: 0 0 -2px;
      font-size: 11px;
      color: #ad931a;
      @media (max-width: 960px) {
        font-size: 10px;
      }
    }
    &:before{
      content: "";
      display: block;
      position: absolute;
      left: -6px; bottom: 0;
      border-right: #fff0a9 8px solid;
      border-top: transparent 8px solid;
      border-bottom: #fff0a9 20px solid;
      border-left: transparent 10px solid;
    }
  }
}

.setLive{
  position: fixed;
  right: 600px; top: 40px;
  background-color: #fff;
  padding: 10px;
  z-index: 9999;
  cursor: pointer;
  &:hover{
    background-color: #eee;
  }
}
.logo{
  width: 160px; height: 200px;
  background-color: green;
  margin: 20px auto;
}
.stages{
  display: flex;
  justify-content: center;
  position: absolute;
  top: 50%; left: 0; right: 0;
  z-index: 9;
  transform: translateY(-50%);
  flex-wrap: wrap;
  @media (max-height: 680px) {
    position: relative;
    transform: none;
    top: auto; right: auto; left: auto;
  }
  @media (max-height: 680px) and (min-width: 681px) {
    padding: 100px 0;
  }
  @media (max-width: 680px) {
    display: block;
    position: relative;
    transform: none;
    top: auto; right: auto; left: auto;
  }
  .stageItem{
    width: 33.33333%; height: 240px;
    box-sizing: border-box;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;
    @media (max-height: 840px) {
      height: 200px;
    }
    @media (max-width: 680px) {
      width: auto;
      margin: 0 40px;
    }
    &.clark{
      animation: stageAnimation 10s infinite linear;
      background-image: url(https://storage.googleapis.com/deepdivedjkt/clg/speakers/clark.png);
      width: 34%;
      @media (max-width: 680px) {
        width: auto;
        margin-left: 0px;
        height: 230px;
      }
    }
    &.sarah{
      animation: stageAnimation 10s infinite linear;
      background-image: url(https://storage.googleapis.com/deepdivedjkt/clg/speakers/sarah.png);
      width: 34%;
      @media (max-width: 680px) {
        width: auto;
      }
    }
    &.dhelya{
      animation: stageAnimation 10s infinite linear;
      background-image: url(https://storage.googleapis.com/deepdivedjkt/clg/speakers/dhelya.png);
      height: 200px;
      @media (max-height: 840px) {
        height: 180px;
      }
    }
    &.yura{
      animation: stageAnimation2 10s infinite linear;
      background-image: url(https://storage.googleapis.com/deepdivedjkt/clg/speakers/yura.png);
    }
    &.testimoni{
      animation: stageAnimation 10s infinite linear;
      background-image: url(https://storage.googleapis.com/deepdivedjkt/clg/speakers/speaker-testimoni.png);
    }
  }
  .stageHeader{
    width: 100%;
    text-align: center;
    @media (max-width: 680px) {
      padding-top: 64px;
    }
    h4{
      text-transform: uppercase;
      margin: 0 0 40px;
      font-family: CarlaSansBold;
      font-size: 30px;
      @media (max-width: 680px) {
        margin-bottom: 20px;
      }
      @media (max-height: 840px) {
        margin-bottom: 20px;
      }
    }
  }
  .stageFooter{
    width: 100%;
    .countdown{
      width: 280px; height: 80px;
      border-radius: 50px;
      text-align: center;
      margin: 40px auto 16px;
      background-image: url(../assets/countdown-noshadow.png);
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      display: flex;
      justify-content: center;
      box-sizing: border-box;
      padding-top: 22px;
      .cdItem{
        font-size: 36px;
        text-align: center;
        width: 80px;
        span{
          display: block;
          font-size: 15px;
          font-weight: normal;
          margin-top: -10px;
        }
      }
    }
    .stftAction{
      display: flex;
      justify-content: center;
      @media (max-width: 680px) {
        display: block;
        text-align: center;
        padding-bottom: 80px;
      }
      .actDate{
        background-color: #ffd2d9;
        margin: 0 10px;
        padding: 9px 34px 0;
        border-radius: 50px;
        text-align: center;
        font-family: CarlaSansBold;
        font-size: 14px;
        box-sizing: border-box;
        height: 50px;
        @media (max-width: 680px) {
          display: inline-block;
          margin-bottom: 16px;
          padding-left: 20px;
          padding-right: 24px;
          font-size: 12px;
          height: 44px;
        }
      }
      .actAdd2Cal{
        margin: 0 10px;
        box-shadow: 2px 2px 6px rgba(0,0,0,.2);
        @media (max-width: 680px) {
          font-size: 17px;
        }
      }
    }
  }
  @keyframes stageAnimation {
    0% {transform: translateY(0);}
    50% {transform: translateY(16px);}
    100% {transform: translateY(0);}
  }
  @keyframes stageAnimation2 {
    0% {transform: translateY(16px);}
    50% {transform: translateY(0);}
    100% {transform: translateY(16px);}
  }
}
.cloud{
  position: fixed;
  width: 400px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  // background-color: blue;
  &.cloud1{
    height: 80px; top: 200px;
    animation: cloudAnimation 18s infinite linear;
    background-image: url(../assets/Mainstage-Awan1.png);
    &.cloud1a{
      animation: cloudAnimation 20s infinite linear;
    }
  }
  &.cloud2{
    height: 300px; top: 80px;
    animation: cloudAnimation 40s infinite linear;
    background-image: url(../assets/Mainstage-Awan3.png);
  }
  &.cloud3{
    height: 140px; top: 200px;
    animation: cloudAnimation 24s infinite linear;
    background-image: url(../assets/Mainstage-Awan2.png);
    &.cloud3a{
      animation: cloudAnimation 30s infinite linear;
    }
  }
}
@keyframes cloudAnimation {
  from {right: -400px;}
  to {right: 100%;}
}
.fruitCnt{
  position: fixed;
  width: 1024px; top: 0; bottom: 0; left: 50%;
  transform: translateX(-50%);
  .fruit{
    width: 140px; height: 140px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    position: fixed;
    &.fr1{
      left: -180px; top: 240px;
      background-image: url(../assets/Mainstage-Buah3.png);
      animation: fruitAnimation 10s infinite ease;
    }
    &.fr2{
      left: -100px; bottom: 200px;
      display: none;
    }
    &.fr3{
      left: 240px; bottom: 220px;
      width: 80px; height: 80px;
      background-image: url(../assets/Mainstage-Buah1.png);
      animation: fruitAnimation2 10s infinite ease;
    }
    &.fr4{
      right: 200px; bottom: 120px;
      background-image: url(../assets/Mainstage-Buah4.png);
      display: none;
    }
    &.fr5{
      right: 100px; bottom: 120px;
      animation: fruitAnimation 10s infinite ease;
      background-image: url(../assets/Mainstage-Kolagen.png);
    }
    &.fr6{
      right: 0; top: 280px;
      animation: fruitAnimation2 10s infinite ease;
      background-image: url(../assets/Mainstage--Buah2.png);
    }
    &.fr7{
      right: -100px; top: 100px;
      display: none;
    }
  }
  @keyframes fruitAnimation {
    0% {transform: translateY(0);}
    50% {transform: translateY(14px);}
    100% {transform: translateY(0);}
  }
  @keyframes fruitAnimation2 {
    0% {transform: translateY(14px);}
    50% {transform: translateY(0);}
    100% {transform: translateY(14px);}
  }
}
</style>
